import type {RuleValidationErrors} from '../types';
import {
	DateSubType,
	DateNoValueTypes,
	DateSingleValueTypes,
	DateSystemDefinedTypes,
} from './constants';
import type {DateRule} from './types';
import {createValidationObject} from '../../utils/createValidationObject';

const validateDate = (date: string) =>
	/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/.test(date);

export const validateDateRule = <T extends DateRule = DateRule>(
	rule: T,
): RuleValidationErrors | false => {
	const hasElementValue1 = rule.elementValue1 !== '';
	const hasElementValue2 = rule.elementValue2 !== '';
	const hasElementValue3 = rule.elementValue3 !== '';

	const errors: RuleValidationErrors = {};

	if (
		// if system defined, then no value3 should be set
		(DateSystemDefinedTypes.includes(rule.elementSubType1 as any) &&
			hasElementValue3) ||
		// if not system defined, then value3 should be set
		(!DateSystemDefinedTypes.includes(rule.elementSubType1 as any) &&
			!hasElementValue3)
	)
		errors.elementValue3 = createValidationObject();

	// if no values should be set
	if ((DateNoValueTypes as readonly number[]).includes(rule.elementSubType2)) {
		if (hasElementValue1) errors.elementValue1 = createValidationObject();
		if (hasElementValue2) errors.elementValue2 = createValidationObject();
	}
	// if only a single value, value1 should be set but not value2
	else if (
		(DateSingleValueTypes as readonly number[]).includes(rule.elementSubType2)
	) {
		if (!hasElementValue1 || !validateDate(rule.elementValue1))
			errors.elementValue1 = createValidationObject();
		if (hasElementValue2) errors.elementValue2 = createValidationObject();
	}
	// if `in_between` then we need a value1 and value2 set
	else if (rule.elementSubType2 === DateSubType.IN_BETWEEN) {
		const compareStartValue = new Date(rule.elementValue1).getTime();
		const compareEndValue = new Date(rule.elementValue2).getTime();

		if (!hasElementValue1 || !validateDate(rule.elementValue1))
			errors.elementValue1 = createValidationObject();
		if (
			!hasElementValue2 ||
			!validateDate(rule.elementValue2) ||
			compareStartValue >= compareEndValue
		)
			errors.elementValue2 = createValidationObject();
	}

	return Object.keys(errors).length ? errors : false;
};

export default validateDateRule;
